import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { Route, Switch } from 'react-router-dom'
import HomeNew from 'src/apps/Home'
import ContainerLayout1 from 'src/components/Home/ContainerLayout1'
import ContainerLayout2 from 'src/components/Home/ContainerLayout2'
import ContainerLayout3 from 'src/components/Home/ContainerLayout3'
import ElacHomeLayout from 'src/custom/elac/components/HomeLayout'
import FuseHomeLayout from 'src/custom/fuse/components/HomeLayout'
import GNS3HomeLayout from 'src/custom/gns3/Home/Layout'
import MotherHomeLayout from 'src/custom/mother-co/components/HomeLayout'
import Actions from 'src/components/Home/Actions'
import { useOrganization } from 'src/graphql/hooks'
import HomeEdit from './Edit'

// =======================================================
// Container Layouts
// =======================================================

const containerLayouts = [
   null,
   ContainerLayout1,
   ContainerLayout2,
   ContainerLayout3,
   // TODO: This is a Layout for use only for Fuse Temporarily
   // See PR: #309
   FuseHomeLayout,
   // TODO: This is a Layout for use only for Mother Temporarily
   // See PR: #318
   MotherHomeLayout,
   // TODO: This is a Layout for use only for ELAC Temporarily
   // See PR: #334
   ElacHomeLayout,
   // TODO: This is a Layout for use only for GNS3 Temporarily
   // See PR: #337
   GNS3HomeLayout,
   // TODO: This is a Layout for use only for Mother
   // This will not be necessary once the new App concept is fully executed
   // See PR: #390
   HomeNew
]

// =======================================================
// Container Component
// =======================================================

const Home = ({ location, match }) => {
   const { organization } = useOrganization()
   const { currentUserCanEdit, homeContainerLayoutKey } = organization

   const defaultLayout = containerLayouts[1]
   const ContainerLayout = containerLayouts[homeContainerLayoutKey] || defaultLayout

   return (
      <>
         <Helmet title={organization.name} />
         <Switch>
            <Route exact path="/">
               <ContainerLayout organization={organization} />
               {currentUserCanEdit && <Actions />}
            </Route>
            {currentUserCanEdit && <Route path="/home/edit" component={HomeEdit} />}
         </Switch>
      </>
   )
}

Home.propTypes = {
   location: PropTypes.object.isRequired,
   match: PropTypes.object.isRequired
}

export default Home
